export const API_ENDPOINTS = {
  login: "/api/admin/login",
  changePassword: "/api/admin/change-password",
  refreshToken: "/user/refreshToken",

  // Dashboard API
  //HRMS
  getDashboardDataHRMS: "/api/superAdmin/getDashboardData",
  getAdminHRMS: "/api/superAdmin/getAdminList",
  createAdminHRMS: "/api/superAdmin/addAdmin",
  updateAdminHRMS: "/api/superAdmin/editAdmin",
  updateEmployeeHRMS: "/api/superAdmin/editEmployee",
  deleteAdminHRMS: 'api/superAdmin/deleteAdmin',
  previewHardDeleteCompanyHRMS: '/api/superAdmin/hardDeleteCompany/preview',
  hardDeleteCompanyHRMS: '/api/superAdmin/hardDeleteCompany',
  hardDeleteCompanyStatusHRMS: '/api/superAdmin/hardDeleteCompany/status',
  empListHRMS: '/api/superAdmin/getEmployeeList',
  compyRgetVerfy: '/CompanyReg/verify-registration',
  getWeeklyStatsHRMS: "/api/stats/weekly",
  getLoginActivityHRMS: "/api/stats/login-activity",
  getActivityReportHRMS: "/api/superAdmin/activity-report",
  getActivityOverviewHRMS: "/api/superAdmin/activity-report/overview",
  getPunchFailuresHRMS: "/api/superAdmin/punch-failures",
  getPunchFailureFiltersHRMS: "/api/superAdmin/punch-failures/filters",
  getPunchesHRMS: "/api/superAdmin/punches",

  //PMS
  getDashboardDataPMS: "/v1/superAdmin/getDashboardData",
  deleteAdminPMS : '/v1/superAdmin/deleteAdmin',
  updateAdminPMS : '/v1/superAdmin/editAdmin',
  createAdminPMS : '/v1/superAdmin/addAdmin',
  getAdminPMS : '/v1/superAdmin/getAdminList',
  empListPMS : '/v1/superAdmin/getUsersList',
  updateEmployeePMS: "/v1/superAdmin/editUser",
  deleteEmployePMS : '/v1/superAdmin/deleteUser',
  getWeeklyStatsPMS: "/v1/superAdmin/weekly-stats",
  getLoginActivityPMS: "/v1/superAdmin/login-activity",
  getActivityReportPMS: "/v1/superAdmin/activity-report",
  getActivityOverviewPMS: "/v1/superAdmin/activity-report/overview",

  //Econnect
  getDashboardDataEconnect: "/v1/superAdmin/getDashboardData",
  createAdminEconnect: '/v1/superAdmin/addAdmin',
  getAdminEconnect: '/v1/superAdmin/getAdminList',
  deleteAdminEconnect: '/v1/superAdmin/deleteAdmins',
  updateAdminEconnect: '/v1/superAdmin/editAdmin',
  empListEconnect : '/v1/superAdmin/getUsersList',
  updateEmployeeEconnect: "/v1/superAdmin/editUser",
  deleteEmployeEconnect : '/v1/superAdmin/deleteUser',
  getWeeklyStatsEconnect: "/v1/superAdmin/weekly-stats",
  getLoginActivityEconnect: "/v1/superAdmin/login-activity",

  //CRM
  getDashboardDataCRM: "/api/superAdmin/getDashboardData",
  getAdminCRM: "/api/superAdmin/getAdminList",
  updateAdminCRM: "/api/superAdmin/editAdmin",
  deleteAdminCRM: 'api/superAdmin/deleteAdmin',
  empListCRM: '/api/superAdmin/getEmployeeList',
  deleteAdminsCRM: 'api/superAdmin/deleteAdmins',
  updateEmployeeCRM: "/api/superAdmin/editEmployee",
  getWeeklyStatsCRM: "/api/superAdmin/weekly-stats",
  getLoginActivityCRM: "/api/superAdmin/login-activity",
  getActivityReportCRM: "/api/superAdmin/activity-report",
  getActivityOverviewCRM: "/api/superAdmin/activity-report/overview",

  // Company-level permissions (per admin/company)
  getCompanyPermissions: "/api/superAdmin/company-permissions",  // append /:companyId
  updateCompanyPermissions: "/api/superAdmin/company-permissions", // append /:companyId

  // Per-company plan settings (dates, limits, plan assignment)
  updateCompanyPlanSettings: "/api/superAdmin/company-plan-settings", // append /:companyId

  // Plans & Permission Management (under superAdmin prefix)
  getPlansAll: "/api/superAdmin/plans/all",
  getPlans: "/api/superAdmin/plans",
  createPlan: "/api/superAdmin/plans",
  updatePlan: "/api/superAdmin/plans",       // append /:planId
  deletePlan: "/api/superAdmin/plans",       // append /:planId
  getPlanById: "/api/superAdmin/plans",      // append /:planId
  getModules: "/api/superAdmin/plans/modules",
  updatePlanPermissions: "/api/superAdmin/plans", // append /:planId/permissions
  getPlanCompanies: "/api/superAdmin/plans",      // append /:planId/companies

  //payroll
  getWeeklyStatsPAYROLL: "/api/v1/superAdmin/weekly-stats",
  getDashboardDataPAYROLL: "/api/v1/superAdmin/getDashboardData",
  getAdminPayroll: "/api/v1/superAdmin/getAdminList",
  updateAdminPayroll: "/api/v1/superAdmin/editAdmin",
  empListPayroll: '/api/v1/superAdmin/getEmployeeList',
  updateEmployeePayroll: "/api/v1/superAdmin/editEmployee",
  deleteAdminPayroll: 'api/v1/superAdmin/deleteAdmin',
  deleteAdminsPayroll: 'api/v1/superAdmin/deleteAdmins',
  getLoginActivityPAYROLL: "/api/v1/superAdmin/login-activity",
  getActivityReportPAYROLL: "/api/v1/superAdmin/activity-report",
  getActivityOverviewPAYROLL: "/api/v1/superAdmin/activity-report/overview",

  // Company health (list; append /:companyId for detail)
  getCompanyHealthHRMS: "/api/superAdmin/company-health",
  getCompanyHealthPAYROLL: "/api/v1/superAdmin/company-health",
  getCompanyHealthCRM: "/api/superAdmin/company-health",
  getCompanyHealthPMS: "/v1/superAdmin/company-health",

  // User management (Super Admin server)
  users: "/api/users",
  assignableCompanies: "/api/users/companies",
  myCompanies: "/api/me/companies",
  myHealth: "/api/me/health",


};
